// Sort results by chart
const ChartShape = ({
  ChartId,
  ChartTitle,
  Contact,
  ChartDescription,
  Categories,
  ChartNotes,
  states,
  activeKeys,
}) => ({
  ChartId,
  ChartTitle,
  Contact,
  ChartDescription,
  Categories,
  ChartNotes,
  states,
  activeKeys,
});

const ChartStateShape = ({ ChartStateId, ChartState, topics, activeKeys, StateCode }) => ({
  ChartStateId,
  ChartState,
  topics,
  activeKeys,
  StateCode,
});

function getChartsArrangedByTopicAndState(chartsState) {
  const chartsArrangedByTopicAndState = chartsState.reduce((acc, current, index) => {
    // chart already exists
    const chartObj = acc.find(item => item.ChartId === current.ChartId);
    if (chartObj) {
      // chartsArrangedByTopicAndState contains ChartShape{} with states[ChartStateShape{}] with matching ChartStateId
      // IOW [{
      //   ChartId: current.ChartId,
      //   states: [{
      //     ChartStateId: current.ChartStateId,
      //     topics: [current]
      //   }]
      // }]
      const existingState = chartObj.states.find(
        item => item.ChartStateId === current.ChartStateId
      );
      // state already exists
      if (existingState) {
        existingState.topics.push(current);
        // add new state
      } else {
        chartObj.states.push(
          new ChartStateShape({
            ChartStateId: current.ChartStateId,
            ChartState: current.ChartState,
            StateCode: current.StateCode,
            activeKeys: [],
            topics: [current],
          })
        );
      }
    } else {
      acc.push(
        new ChartShape({
          ChartTitle: current.ChartTitle,
          ChartId: current.ChartId,
          Contact: current.Contact,
          ChartDescription: current.ChartDescription,
          Categories: current.Categories,
          ChartNotes: current.ChartNotes,
          activeKeys: [index === 0 ? current.ChartId.toString() : undefined],
          states: [
            new ChartStateShape({
              ChartStateId: current.ChartStateId,
              ChartState: current.ChartState,
              StateCode: current.StateCode,
              activeKeys: [],
              topics: [current],
            }),
          ],
        })
      );
    }
    return acc;
  }, []);
  return chartsArrangedByTopicAndState;
}

// Sort search results by state

const StateShape = ({ StateCode, ChartState, charts }) => ({
  StateCode,
  ChartState,
  charts,
});

const StateChartShape = ({
  ChartId,
  ChartTitle,
  Contact,
  ChartDescription,
  Categories,
  ChartNotes,
  topics,
  ChartStateId,
}) => ({
  ChartId,
  ChartTitle,
  Contact,
  ChartDescription,
  Categories,
  ChartNotes,
  topics,
  ChartStateId,
});

/*
{
  StateCode: 'AL',
  StateDescription: 'Alabama',
  charts: [
    {
      ChartStateId: current.ChartStateId,
      topics: [current]
    }
  ]

}


*/
function getChartsArrangedByState(chartsState) {
  const chartsArrangedByState = chartsState.reduce((acc, current, index) => {
    // state already exists
    const stateObj = acc.find(item => item.StateCode === current.StateCode);
    if (stateObj) {
      const existingState = stateObj.charts.find(
        item => item.ChartStateId === current.ChartStateId
      );
      // state already exists
      if (existingState) {
        existingState.topics.push(current);
        // add new state
      } else {
        stateObj.charts.push(
          new StateChartShape({
            ChartId: current.ChartId,
            ChartTitle: current.ChartTitle,
            Contact: current.Contact,
            ChartDescription: current.ChartDescription,
            Categories: current.Categories,
            ChartNotes: current.ChartNotes,
            ChartStateId: current.ChartStateId,
            topics: [current],
          })
        );
      }
    } else {
      acc.push(
        new StateShape({
          StateCode: current.StateCode,
          ChartState: current.ChartState,
          charts: [
            new StateChartShape({
              ChartId: current.ChartId,
              ChartTitle: current.ChartTitle,
              Contact: current.Contact,
              ChartDescription: current.ChartDescription,
              Categories: current.Categories,
              ChartNotes: current.ChartNotes,
              ChartStateId: current.ChartStateId,
              topics: [current],
            }),
          ],
        })
      );
    }
    return acc;
  }, []);
  return chartsArrangedByState;
}

function getPaginatedCharts(allCharts, currentpage) {
  // eslint-disable-next-line no-param-reassign
  currentpage -= 1;
  return allCharts.slice(currentpage * 10, (currentpage + 1) * 10);
}

// transform saved searches schema to an array
function getSavedSearchesList(savedSearchesObj) {
  return Object.keys(savedSearchesObj).map(searchKey => savedSearchesObj[searchKey]);
}

function getSelectedSearch(searchId, savedSearchesGroup) {
  if (searchId && savedSearchesGroup[searchId]) {
    return savedSearchesGroup[searchId];
  }
  return {
    SearchId: null,
    PersonId: null,
    SearchDescription: '',
    FieldOptions: {
      Categories: [],
      Charts: [],
      States: [],
      SearchText: '',
      Page: null,
      PageSize: null,
      SortField: null,
      SortOrder: null,
    },
  };
}

export {
  getChartsArrangedByState,
  getChartsArrangedByTopicAndState,
  getPaginatedCharts,
  getSavedSearchesList,
  getSelectedSearch,
};
